import { createApiRef } from '@backstage/core-plugin-api';

const badgesApiRef = createApiRef({
  id: "plugin.badges.client"
});
const BADGE_STYLES = [
  "plastic",
  "flat",
  "flat-square",
  "for-the-badge",
  "social"
];

export { BADGE_STYLES, badgesApiRef };
//# sourceMappingURL=types.esm.js.map
